import SITE_ENVIRONMENTS from './websites'

const ANALYTICS = {
  HUB_PROFILE_ID_COOKIE_NAME: 'achieve_profile_id',
  SESSION_START_EVENTS_TRACKED: 'achieve_session_start_events_tracked',
  BROWSER_ID_KEY_NAME: 'browser_id',
  DATADOG_SITE: 'datadoghq.com',
  LAST_PAGE_LEVEL_EXPERIMENT: 'achieve_last_page_level_experiment',
}

const CHATBOT_ANALYTICS_MAPPING = {
  [SITE_ENVIRONMENTS.ACHIEVE]: 'ACX Chatbot 2',
  [SITE_ENVIRONMENTS.FDR]: 'FDR Chatbot',
}

const APP_CONFIG = {
  NEXT_PUBLIC_SITE_ENVIRONMENT: process.env.NEXT_PUBLIC_SITE_ENVIRONMENT,
  NEXT_PUBLIC_APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,
  // Analytics/Tealium
  NEXT_PUBLIC_ANALYTICS_APP_NAME: process.env.NEXT_PUBLIC_ANALYTICS_APP_NAME,
  NEXT_PUBLIC_ANALYTICS_APP_TITLE: process.env.NEXT_PUBLIC_ANALYTICS_APP_TITLE,
  NEXT_PUBLIC_ANALYTICS_DEBUG: process.env.NEXT_PUBLIC_ANALYTICS_DEBUG,
  NEXT_PUBLIC_ANALYTICS_ENV: process.env.NEXT_PUBLIC_ANALYTICS_ENV,
  NEXT_PUBLIC_TEALIUM_UTAG_URL: process.env.NEXT_PUBLIC_TEALIUM_UTAG_URL,
  // Auth0
  NEXT_PUBLIC_AUTH0_AUDIENCE: process.env.NEXT_PUBLIC_AUTH0_AUDIENCE,
  NEXT_PUBLIC_AUTH0_CLIENT_ID: process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID,
  NEXT_PUBLIC_AUTH0_DOMAIN: process.env.NEXT_PUBLIC_AUTH0_DOMAIN,
  // DataDog
  NEXT_PUBLIC_DATADOG_APPLICATION_ID: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
  NEXT_PUBLIC_DATADOG_CLIENT_TOKEN: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
  NEXT_PUBLIC_DATADOG_ENV: process.env.NEXT_PUBLIC_DATADOG_ENV,
  NEXT_PUBLIC_DATADOG_SERVICE: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
}

Object.freeze(ANALYTICS)
export { ANALYTICS, CHATBOT_ANALYTICS_MAPPING, APP_CONFIG }
